<template>
  <PlainTable :sourceList="itemArray" :useExcel="true" ref="contentTable">
    <template #header>
      <caption>
        <span class="blind">건강톡톡 콘텐츠별 조회수 순위 10</span>
      </caption>
      <colgroup>
        <col width="60px" />
        <col width="300px" />
        <col />
        <col />
        <col />
        <col width="300px" />
      </colgroup>
      <thead class="table_list_head table_list_head_line">
        <tr>
          <th rowspan="2">순위</th>
          <th colspan="4">마음체조 조회수</th>
          <th colspan="2">좋은생각 조회수</th>
        </tr>
        <tr>
          <th>제목</th>
          <th>합계</th>
          <th>검색</th>
          <th>추천</th>
          <th>제목</th>
          <th>합계</th>
        </tr>
      </thead>
    </template>
    <template #row="{rowData}">
      <tr>
        <td>{{rowData.rank}}</td>
        <!-- 마음체조 -->
        <template v-if="rowData.mind">
          <td class="left">{{rowData.mind.title}}</td>
          <td class="right">{{rowData.mind.totalCount}}</td>
          <td class="right">{{rowData.mind.searchCount}}</td>
          <td class="right">{{rowData.mind.recommendCount}}</td>
        </template>
        <template v-else>
          <td v-for="i in 4">-</td>
        </template>
        <!-- 좋은생각 -->
        <template v-if="rowData.goodThinking">
          <td class="left">{{rowData.goodThinking.title}}</td>
          <td class="right">{{rowData.goodThinking.recommendCount}}</td>
        </template>
        <template v-else>
          <td v-for="i in 2">-</td>
        </template>
      </tr>
    </template>
  </PlainTable>
</template>

<script>
export default {
  props: {
    itemArray: Array
  }
};
</script>
